// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"50997d55","582":"04279e2b","766":"805df939","1901":"7a7d6d39","3737":"95d5aa7c","3911":"56932435","4282":"066dfdbf","7567":"b64ce850","9478":"677cb877"}[chunkId] + ".chunk.css";
};